// Rótulos/estilos do estado fiscal (order.fiscal.status) e sugestões de NCM.

export const FISCAL_STATUS = {
  processing: { label: "Emitindo…", tone: "info" },
  sent: { label: "Aguardando SEFAZ", tone: "info" },
  authorized: { label: "NF-e autorizada", tone: "success" },
  error: { label: "Erro na NF-e", tone: "danger" },
  cancelled: { label: "NF-e cancelada", tone: "muted" },
  pending: { label: "NF-e pendente", tone: "warning" },
};

export function fiscalStatusInfo(fiscal) {
  if (!fiscal?.status) return { label: "Sem NF-e", tone: "muted" };
  return (
    FISCAL_STATUS[fiscal.status] || { label: fiscal.status, tone: "muted" }
  );
}

// Pode (re)tentar emitir: sem nota, com erro ou pendente.
export function canEmit(fiscal) {
  return !fiscal?.status || ["error", "pending"].includes(fiscal.status);
}

export function canRefresh(fiscal) {
  return fiscal?.status === "sent" && Boolean(fiscal?.blingNfeId);
}

export function normalizeNcm(value) {
  return String(value || "")
    .replace(/\D/g, "")
    .slice(0, 8);
}

export function isValidNcm(value) {
  return normalizeNcm(value).length === 8;
}

// Sugestão para vestuário feminino de tecido plano em fibra sintética — o NCM
// correto depende do tecido de cada peça, então é só ponto de partida:
// confirmar com o contador antes de ligar a emissão automática.
export const NCM_SUGGESTIONS = {
  jumpsuit: "62114300",
  dress: "62044300",
  blazer: "62043300",
  vest: "62114300",
  top: "62064000",
  shirt: "62064000",
  pants: "62046300",
  short: "62046300",
  bermuda: "62046300",
};

export const DELIVERY_TYPES = [
  { value: "correios", label: "Correios" },
  { value: "jadlog", label: "Jadlog" },
  { value: "motoboy", label: "Motoboy" },
  { value: "presencial", label: "Presencial (balcão)" },
  { value: "manually", label: "Manual" },
];
